export default __webpack_public_path__ + "static/media/TwiterX-colored-IC.798e5dc7.svg";